/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Alert, Label, Col,
} from 'reactstrap';

import {
  Field, useFormikContext,
} from 'formik';

import { get } from '../../helpers/api_helper';

const lazyFilterOption = ({ label }, inputValue) => {
  const query = inputValue.toLocaleLowerCase();
  const candidate = label.toLocaleLowerCase();
  let candidateIndex = 0;

  return Array.from(query).every((character) => {
    candidateIndex = candidate.indexOf(character, candidateIndex);

    if (candidateIndex === -1) {
      return false;
    }

    candidateIndex += 1;
    return true;
  });
};

function SupplierPicker(props) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [supplier, setSupplier] = useState({ name: '', programs: [] });
  // eslint-disable-next-line no-unused-vars

  const { values, setFieldValue } = useFormikContext();

  const handleIdChange = (option) => {
    const supplierId = option ? option.value : '';
    const selectedSupplier = suppliers.find((x) => x.id === supplierId);

    setFieldValue('supplier_id', supplierId);
    setFieldValue('supplier_program', '');
    setSupplier(selectedSupplier || { name: '', programs: [] });
  };

  const handleProgramChange = (option) => {
    setFieldValue('supplier_program', option ? option.value : '');
  };

  useEffect(() => {
    const fetchData = async () => {
      const uri = '/api/sourcing/supplier?per=1000';

      try {
        const data = await get(uri);

        setSuppliers(data.results);

        for (let i = 0; i < data.results.length; i += 1) {
          if (data.results[i].id === values.supplier_id) {
            setSupplier(data.results[i]);
          }
        }
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();
  }, []);

  let results;

  if (!loading && suppliers.length > 0) {
    const opts = suppliers.map((x) => ({ label: x.name, value: x.id }));
    const programOpts = supplier.programs.map((x) => ({ label: x.name, value: x.name }));

    results = (
      <div>
        <div className="row p-0">
          <Label for="supplier_id" className="col-sm-3 col-form-label">{props.t('Supplier')}</Label>
          <Col sm={9} className="pe-0">
            <Field name="supplier_id">
              {({ field, meta }) => (
                <div>
                  <Select
                    inputId="supplier_id"
                    name={field.name}
                    value={opts.find((x) => x.value === values.supplier_id) || null}
                    options={opts.sort((a, b) => a.label.localeCompare(b.label))}
                    onChange={handleIdChange}
                    onBlur={field.onBlur}
                    placeholder={props.t('Select or type a Supplier')}
                    classNamePrefix="supplier-select"
                    filterOption={lazyFilterOption}
                    isClearable
                    isSearchable
                  />
                  {meta.touched && meta.error ? (
                    <div className="text-danger">{meta.error}</div>
                  ) : null}
                </div>
              )}
            </Field>
          </Col>
        </div>

        <div className="row p-0 mt-3">
          <label htmlFor="supplier_program" className="col-sm-3 col-form-label">{props.t('Program')}</label>
          <Col sm={9} className="pe-0">
            <Field name="supplier_program">
              {({ field, meta }) => (
                <div>
                  <Select
                    inputId="supplier_program"
                    name={field.name}
                    value={programOpts.find((x) => x.value === values.supplier_program) || null}
                    options={programOpts.sort((a, b) => a.label.localeCompare(b.label))}
                    onChange={handleProgramChange}
                    onBlur={field.onBlur}
                    placeholder={props.t('Select or type a Program')}
                    classNamePrefix="supplier-select"
                    filterOption={lazyFilterOption}
                    isClearable
                    isSearchable
                  />
                  {meta.touched && meta.error ? (
                    <div className="text-danger">{meta.error}</div>
                  ) : null}
                </div>
              )}
            </Field>
          </Col>
        </div>
      </div>
    );
  } else if (loading) {
    results = (
      <span style={{ fontSize: '15px' }} className="mdi mdi-spin mdi-loading" />
    );
  } else {
    results = (
      <span>{props.t('No suppliers found.')}</span>
    );
  }

  let errorMsg;
  if (error !== false) {
    errorMsg = <Alert color="danger">{error}</Alert>;
  }

  const jsx = (
    <div>
      {errorMsg}
      {results}
    </div>
  );

  return jsx;
}

SupplierPicker.defaultProps = {

};

SupplierPicker.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(SupplierPicker));
